const MenuLoader = () => {
  return (
    <div className="menuloader">
      <div className="ui large loader"></div>
    </div>
  );
};

export default MenuLoader;
